import { Skeleton } from 'antd';
import styled from 'styled-components';

export const StyledSkeleton = styled(Skeleton)`
  max-height: 4rem;
`;
